export default __webpack_public_path__ + "static/media/torus.6eb10dd4.svg";